/** Shared typography class names — compact UI scale across pages. */
export const typography = {
  pageTitle: 'text-base font-semibold tracking-tight text-slate-900 dark:text-slate-50',
  pageSubtitle: 'text-xs text-slate-500 dark:text-slate-400 mt-0.5',
  sectionTitle: 'text-sm font-semibold text-slate-900 dark:text-slate-100',
  body: 'text-xs text-slate-700 dark:text-slate-300',
  bodyMuted: 'text-xs text-slate-500 dark:text-slate-400',
  label: 'text-[10px] font-medium uppercase tracking-wide text-slate-500 dark:text-slate-400',
  tableHeader: 'text-[10px] font-semibold uppercase tracking-wide text-slate-500 dark:text-slate-400',
  tableCell: 'text-xs text-slate-800 dark:text-slate-200',
  sidebarParent: 'text-xs font-medium leading-snug',
  sidebarChild: 'text-[11px] font-normal leading-snug',
};
